import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=75b18508&scoped=true"
import script from "./Todos.vue?vue&type=script&lang=ts"
export * from "./Todos.vue?vue&type=script&lang=ts"
import style0 from "./Todos.vue?vue&type=style&index=0&id=75b18508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b18508",
  null
  
)

export default component.exports